import React from "react";
import { isIE } from "react-device-detect";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import { groupBy, get } from "lodash";

import {
  setPermissions,
  setAccountInfo,
  setAppSettings,
} from "../../reducers/user/actions";
import { getSettingsSites } from "../../reducers/sites/actions";
import {
  getUserToken,
  getUserInfo,
  getLanguages,
} from "../../reducers/user/selectors";
import { logout, updateUser } from "../../reducers/user/actions";

import Home from "../../containers/Home/Home";
import { NotFound } from "../../containers/Static/NotFound";
import ValidateRandomization from "../../containers/ValidateRandomization/ValidateRandomization";
import Documents from "../../containers/Documents/Documents";
import PrivacyPolicy from "../../containers/PrivacyPolicy/PrivacyPolicy";

import Login from "../../containers/Login/Login";
import ResetPassword from "../../containers/ResetPassword/ResetPassword";
import ResetPasswordSend from "../../containers/ResetPasswordSend/ResetPasswordSend";
import SetAccountPassword from "../../containers/SetAccountPassword/SetAccountPassword";
import AdminDashboard from "../../containers/AdminDashboard/AdminDashboard";
import PatientProfile from "../../containers/PatientProfile/PatientProfile";
import PatientProfileCreate from "../../containers/PatientProfileCreate/PatientProfileCreate";
import SAEReporting from "../../containers/SAEReporting/SAEReporting";
import ApiConfiguration from "../../containers/ApiConfiguration/ApiConfiguration";
import FollowUp7Day from "../../containers/FollowUp7Day/FollowUp7Day";
import FollowUp30Day from "../../containers/FollowUp30Day/FollowUp30Day";
import PatientDashboard from "../../containers/PatientDashboard/PatientDashboard";
import MyProfile from "../../containers/MyProfile/MyProfile";
import Enrolments from "../../containers/Enrolments/Enrolments";
import EnrolmentsRandomized from "../../containers/Enrolments/EnrolmentsRandomized";
import AdminSettings from "../../containers/AdminSettings/AdminSettings";
import SettingsSites from "../../containers/SettingsSites/SettingsSites";
import SettingsUsers from "../../containers/SettingsUsers/SettingsUsers";
import SettingsUsersPatientPortal from "../../containers/SettingsUsers/SettingsUsersPatientPortal";
import SettingsUsersBulk from "../../containers/SettingsUsersBulk/SettingsUsersBulk";
import SettingsRoles from "../../containers/SettingsRoles/SettingsRoles";
import SettingsRolesSuperAdmin from "../../containers/SettingsRoles/SettingsRolesSuperAdmin";
import DocumentsEditor from "../../containers/DocumentsEditor/DocumentsEditor";
import FinanceCustomersEditor from "../../containers/FinanceCustomersEditor/FinanceCustomersEditor";
import QualityControl from "../../containers/QualityControl/QualityControl";
import FinancePricesEditor from "../../containers/FinancePricesEditor/FinancePricesEditor";
import FinanceInvoicesEditor from "../../containers/FinanceInvoicesEditor/FinanceInvoicesEditor";
import SettingsConsent from "../../containers/SettingsConsent/SettingsConsent";
import SettingsConsentSingle from "../../containers/SettingsConsent/SettingsConsentSingle";
import DocumentsTraining from "../../containers/DocumentsTraining/DocumentsTraining";
import DocumentsPublic from "../../containers/DocumentsPublic/DocumentsPublic";
import DocumentsPerSite from "../../containers/DocumentsPublic/DocumentsPerSite";
import DocumentsPerSitePrivate from "../../containers/DocumentsPublic/DocumentsPerSitePrivate";
import DocumentsGeneral from "../../containers/DocumentsPublic/DocumentsGeneral";
import DocumentsGeneralPrivate from "../../containers/DocumentsPublic/DocumentsGeneralPrivate";
import DocumentsValidation from "../../containers/DocumentsPublic/DocumentsValidation";
import SettingsUserRoles from "../../containers/SettingsUserRoles/SettingsUserRoles";
import SettingsGeneral from "../../containers/SettingsGeneral/SettingsGeneral";
import AuditLogs from "../../containers/AuditLogs/AuditLogs";
import Simulation from "../../containers/Simulation/Simulation";
import DrugsEditor from "../../containers/DrugsEditor/DrugsEditor";
import RandomizePage from "../../containers/RandomizePage/RandomizePage";
import RandomizePageOld from "../../containers/RandomizePage/RandomizePageOld";
// import RandomizeAdmin from "../../containers/RandomizeAdmin/RandomizeAdmin";
import EnrolmentsRandomize from "../../containers/EnrolmentsRandomize/EnrolmentsRandomize";
import Inventory from "../../containers/Inventory/Inventory";
import ProfileList from "../../containers/ProfileList/ProfileList";
import FinanceGeneratedEvents from "../../containers/FinanceGeneratedEvents/FinanceGeneratedEvents";
import Newsletter from "../../containers/Newsletter/Newsletter";
import CustomFormList from "../../containers/CustomFormList/CustomFormList";
import CustomFormCreate from "../../containers/CustomFormCreate/CustomFormCreate";
import RandomizePreConsentStep1 from "../../containers/RandomizePage/RandomizePreConsentStep1";
import CustomFormUpdate from "../../containers/CustomFormUpdate/CustomFormUpdate";
import Consent from "../../containers/Consent/Consent";
import FormBuilder from "../../containers/FormBuilder/FormBuilder";
import ConsentTypeLhs from "../ConsentTypeLhs/ConsentTypeLhs";
import ConsentTypeMevo from "../ConsentTypeMevo/ConsentTypeMevo";
import ConsentTypeMevoV2 from "../ConsentTypeMevoV2/ConsentTypeMevoV2";
import ConsentTypeWorkflowV2_1 from "../ConsentTypeWorkflowV2_1/ConsentTypeWorkflowV2_1";
import ConsentTypeHope_ii_V2_1 from "../ConsentTypeHope_ii_V2_1/ConsentTypeHope_ii_V2_1";
import ConsentError from "../ConsentError/ConsentError";
import SettingsTranslations from "../SettingsTranslations/SettingsTranslations";
import SettingsLanguages from "../SettingsLanguages/SettingsLanguages";
import SettingsPatientEvents from "../SettingsPatientEvents/SettingsPatientEvents";
import WizardConfig from "../WizardConfig/WizardConfig";
import PageLayout from "../PageLayout/PageLayout";
import ContactUs from "../../containers/ContactUs/ContactUs";
import DelegationLogs from "../../containers/DelegationLogs/DelegationLogs";
import DelegationLogsSigning from "../../containers/DelegationLogs/DelegationLogsSigning";
import EditDelegationLogSigning from "../../containers/DelegationLogs/EditDelegationLogSigning";
import EditDelegation from "../../containers/DelegationLogs/EditDelegation";
import DocumentManagementDashboard from "../../containers/DocumentManagementDashboard/DocumentManagementDashboard";
import DocumentsEtmfSchema from "../../containers/DocumentsEtmfSchema/DocumentsEtmfSchema";
import ConsentUnassignedRecords from "../../containers/ConsentUnassignedRecords/ConsentUnassignedRecords";
import PermutedBlocks from "../../containers/PermutedBlocks/PermutedBlocks";
import EmailTemplates from "../../containers/EmailTemplates/EmailTemplates";
import WindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import SpecimenSampleEditor from "../../containers/SpecimenSampleEditor/SpecimenSampleEditor";
import SpecimenSamplesSettings from "../../containers/SpecimenSamplesSettings/SpecimenSamplesSettings";
import SamlConfig from "../../containers/SamlConfig/SamlConfig";
import SamlLogin from "../../containers/SamlLogin/SamlLogin";

import classNames from "classnames";

import classes from "./App.css";
import IdleTimer from "react-idle-timer";
import Reporting from "../Reporting/Reporting";
import Unblindings from "../Unblindings/Unblindings";
import PrivacyConsent from "../../components/PrivacyConsent/PrivacyConsent";
import DocumentsStudyRegulatoryBinder from "../DocumentsStudyRegulatoryBinder/DocumentsStudyRegulatoryBinder";
import DocumentsPharmacyBinder from "../DocumentsPharmacyBinder/DocumentsPharmacyBinder";
import { withNamespaces } from "react-i18next";
import i18n from "../../i18n";
import {
  listTranslations,
  getLastUpdatedTranslation,
  listLanguages,
} from "../../api/requests";
import {
  TRANSLATIONS_STORAGE_KEY,
  TIMESTAMP_STORAGE_KEY,
} from "../../constants";
import SettingsTheme from "../../containers/SettingsTheme/SettingsTheme";
import { fetchTheme } from "../../reducers/theme/actions";
import { getTheme } from "../../reducers/theme/selectors";

const routes = require("../../routes.json");

const getPromise = async (promise) => {
  return Promise.resolve().then(() => promise);
};

const callTasks = async (promises) => {
  const promise = await getPromise(promises.shift());

  if (!promises.length) {
    return promise;
  }

  return callTasks(promises);
};

class App extends React.Component {
  constructor(props) {
    super(props);

    this.idleTimer = null;

    this.handleOnIdle = this.handleOnIdle.bind(this);

    this.state = {
      isLoading: false,
    };
  }

  handleOnIdle(event) {
    if (this.props.token && process.env.NODE_ENV !== "development") {
      this.props.logout();
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.token && !prevProps.token) {
      this.setState({ isLoading: true });
      const { data: languages } = await listLanguages({ status: "active" });
      const userLanguageId = this.props.userInfo.language || languages[0].id;

      this.initTranslations(languages, userLanguageId);
    }
  }

  async initTranslations(languages, userLanguageId) {
    if (!languages.length) {
      return;
    }

    let cachedTranslations = JSON.parse(
      window.localStorage.getItem(TRANSLATIONS_STORAGE_KEY)
    );

    const cachedTimestamp = window.localStorage.getItem(TIMESTAMP_STORAGE_KEY);

    let translations = cachedTranslations;

    const {
      data: { updated },
    } = await getLastUpdatedTranslation({ languageId: userLanguageId });

    const freshTimestamp = updated || "NONE";

    this.props.updateUser({ languages });

    if (cachedTimestamp !== freshTimestamp || !cachedTimestamp) {
      window.localStorage.setItem(TIMESTAMP_STORAGE_KEY, freshTimestamp);

      const userLanguage = languages.find((item) => item.id === userLanguageId);

      translations = (await listTranslations({ locale: userLanguage.code }))
        .data;

      cachedTranslations = translations;

      window.localStorage.setItem(
        TRANSLATIONS_STORAGE_KEY,
        JSON.stringify(translations)
      );
    }

    this.loadTranslations(cachedTranslations, languages, userLanguageId);
  }

  initialLoadCachedTranslations(languages, userLanguageId) {
    const cachedTranslations = JSON.parse(
      window.localStorage.getItem(TRANSLATIONS_STORAGE_KEY)
    );

    this.loadTranslations(cachedTranslations, languages, userLanguageId, true);
  }

  async loadTranslations(translations, languages, userLanguageId, isCached) {
    const groupedTranslations = groupBy(translations, "module");

    const formattedTranslations = Object.keys(groupedTranslations).reduce(
      (result, namespace) => {
        result[namespace] = groupedTranslations[namespace].reduce(
          (result, item) => {
            result[item.key] = item.value;
            return result;
          },
          {}
        );

        return result;
      },
      {}
    );

    const selectedLanguage = languages.find(
      (item) => item.id === userLanguageId
    );

    if (!isCached) {
      console.log("!isCached");
      const formattedTranslationKeys = Object.keys(formattedTranslations);

      if (formattedTranslations["translation"]) {
        i18n.addResourceBundle(
          selectedLanguage.code,
          "translation",
          formattedTranslations["translation"]
        );
      }

      if (formattedTranslations["NamespaceAdminDashboard"]) {
        i18n.addResourceBundle(
          selectedLanguage.code,
          "NamespaceAdminDashboard",
          formattedTranslations["NamespaceAdminDashboard"]
        );
      }

      if (formattedTranslations["NamespaceAdminHeader"]) {
        i18n.addResourceBundle(
          selectedLanguage.code,
          "NamespaceAdminHeader",
          formattedTranslations["NamespaceAdminHeader"]
        );
      }

      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 1500);

      for (const namespace of formattedTranslationKeys) {
        await new Promise((res) => {
          if (
            !i18n.hasResourceBundle(selectedLanguage.code, namespace) ||
            namespace === "translation"
          ) {
            i18n.addResourceBundle(
              selectedLanguage.code,
              namespace,
              formattedTranslations[namespace]
            );
          }

          setTimeout(res, 100);
        });
      }
    } else {
      console.log("isCached");
      Object.keys(formattedTranslations).forEach((namespace) => {
        if (
          !i18n.hasResourceBundle(selectedLanguage.code, namespace) ||
          namespace === "translation"
        ) {
          i18n.addResourceBundle(
            selectedLanguage.code,
            namespace,
            formattedTranslations[namespace]
          );
        }
      });
    }

    this.setState({ isLoading: false });

    i18n.changeLanguage(selectedLanguage.code);
  }

  enableTheme = () => {
    if (this.props.theme) {
      document.documentElement.style.setProperty(
        "--primary-color",
        this.props.theme.primary_color
      );

      document.documentElement.style.setProperty(
        "--primary-color-dark",
        this.props.theme.primary_color_dark
      );

      document.documentElement.style.setProperty(
        "--primary-color-light",
        this.props.theme.primary_color_light
      );

      document.documentElement.style.setProperty(
        "--header-color",
        this.props.theme.header_color
      );

      document.documentElement.style.setProperty(
        "--header-item-color",
        this.props.theme.header_item_color
      );

      document.documentElement.style.setProperty(
        "--header-item-highlight-color",
        this.props.theme.header_item_highlight_color
      );

      document.documentElement.style.setProperty(
        "--footer-color",
        this.props.theme.footer_color
      );
    }
  };

  async componentDidMount() {
    this.enableTheme();
    this.analyticsModule();

    this.props.fetchTheme().then(this.enableTheme);

    if (this.props.token) {
      this.props.setAccountInfo(this.props.token);
      let userLanguageId =
        this.props.userInfo.language || get(this.props.languages[0], "id");

      if (this.props.languages.length && userLanguageId) {
        this.initialLoadCachedTranslations(
          this.props.languages,
          userLanguageId
        );
      }

      const { data: languages } = await listLanguages({ status: "active" });

      this.initTranslations(languages, userLanguageId || languages[0].id);
      await this.props.setPermissions(this.props.token);
      await this.props.setAppSettings();
      // this.props.getSettingsSites();
    }
  }

  analyticsModule() {
    console.log(process.env.REACT_APP_ANALYTICS);
    if (process.env.REACT_APP_ANALYTICS === 'TRUE') {
      console.log('ingress set');
      const ingressAnalyticsId = process.env.REACT_APP_INGRESS_ANALYTICS;

      if (ingressAnalyticsId) {
        // Загрузка скрипта Ingress Analytics
        const script = document.createElement('script');
        script.src = `https://analytics.dctms.ca/ingress/${ingressAnalyticsId}/script.js`;
        script.defer = true;
        document.head.appendChild(script);

        // Добавление изображения для no-script тега
        const noscript = document.createElement('noscript');
        const img = document.createElement('img');
        img.src = `https://analytics.dctms.ca/ingress/${ingressAnalyticsId}/pixel.gif`;
        noscript.appendChild(img);
        document.body.appendChild(noscript);
      }
    }
  }

  render() {
    const { isLoading } = this.state;

    if (isIE)
      return (
        <div
          className={classNames(
            classes.errorBox,
            classes.alert,
            classes.verticalCenter
          )}
        >
          <div className={classes.msg}>
            {this.props.i18n.t(
              "NamespaceApp:Error - We noticed that you may be using Internet Explorer as your browser. Unfortunately, this browser does not support the latest features used in our application. Please switch to a modern browser such as Microsoft Edge, Google Chrome, or Mozilla Firefox. Thank you for understanding!"
            )}
          </div>
        </div>
      );

    if (!this.props.theme) {
      return null;
    }

    return (
      <div>
        {isLoading && (
          <div
            style={{
              position: "fixed",
              background: "#F0F1F5",
              zIndex: "9999",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100vh",
            }}
          >
            Loading
          </div>
        )}

        <React.Fragment>
          {/* <button
            onClick={() => {
              const data = require("../../en.json");

              const payload = [];

              Object.keys(data.en).forEach((namespace) =>
                Object.keys(data.en[namespace]).forEach(
                  (key) =>
                    data.en[namespace][key] &&
                    payload.push({
                      module: namespace,
                      key,
                      value: data.en[namespace][key],
                    })
                )
              );

              storeTranslations(payload);
            }}
          >
            Load initial translations
          </button> */}
          {this.props.token && (
            <IdleTimer
              ref={(ref) => {
                this.idleTimer = ref;
              }}
              timeout={1000 * 60 * 10}
              onIdle={this.handleOnIdle}
              debounce={250}
            />
          )}
          <Router>
            <PageLayout>
              <Switch>
                {process.env.REACT_APP_SKIP_LANDING === 'TRUE' ? (
                  <Route exact path="/">
                    <Redirect to={routes.admin.login} />
                  </Route>
                ) : (
                  <Route exact path="/" component={Home} />
                )}
                {/*<Route exact path="/trial-information" component={TrialInformation} />*/}
                {/*<Route exact path="/patient-information-sheet" component={PatientInformationSheet} />*/}
                {/*<Route exact path="/patient-information-sheet-visual" component={PatientInformationSheetVisual} />*/}
                {/*<Route exact path="/patient-information-sheet-text" component={PatientInformationSheetText} />*/}
                {/*<Route exact path="/consent" component={Consent} />*/}
                {/*<Route exact path="/physician-script" component={PhysicianScript} />*/}
                {/*<Route exact path="/randomize" component={Randomize} />*/}
                {/*<Route exact path="/validate-randomization" component={ValidateRandomization} />*/}
                {/*<Route exact path="/sae-recording" component={SaeRecording} />*/}
                <Route exact path="/documents" component={Documents} />
                <Route exact path="/contact-us" component={ContactUs} />
                <Route exact path={routes.patient.index} component={PatientDashboard} />
                <Route exact path={routes.admin.consent} component={Consent} />
                <Route exact path={routes.admin.preconsentRandomization} component={RandomizePreConsentStep1} />
                <Route exact path={routes.admin.consentRandomization}>
                  <Consent consentRandomization />
                </Route>
                <Route
                  exact
                  path={routes.admin.formBuilder}
                  component={FormBuilder}
                />
                <Route
                  exact
                  path={routes.admin.apiConfiguration}
                  component={ApiConfiguration}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeLhs}
                  component={ConsentTypeLhs}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeLhsToken}
                  component={ConsentTypeLhs}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeMevo}
                  component={ConsentTypeMevo}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeMevoToken}
                  component={ConsentTypeMevo}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeMevoV2}
                  component={ConsentTypeMevoV2}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeMevoV2Token}
                  component={ConsentTypeMevoV2}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeWorkflowV2_1}
                  component={ConsentTypeWorkflowV2_1}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeWorkflowV2_1Token}
                  component={ConsentTypeWorkflowV2_1}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeHope_ii_V2_1}
                  component={ConsentTypeHope_ii_V2_1}
                />
                <Route
                  exact
                  path={routes.admin.consentTypeHope_ii_V2_1Token}
                  component={ConsentTypeHope_ii_V2_1}
                />
                <Route exact path="/privacy-policy" component={PrivacyPolicy} />
                <Route exact path={routes.admin.index}>
                  <Redirect to={routes.admin.dashboard} />
                </Route>
                <Route exact path={routes.admin.login} component={Login} />
                <Route
                  exact
                  path={routes.admin.resetPassword}
                  component={ResetPassword}
                />
                <Route
                  exact
                  path={routes.admin.resetPasswordConfirm}
                  component={ResetPasswordSend}
                />
                <Route
                  exact
                  path={routes.admin.setPassword}
                  component={SetAccountPassword}
                />
                <Route
                  exact
                  path={routes.admin.dashboard}
                  component={AdminDashboard}
                />
                <Route
                  exact
                  path={routes.admin.themeSettings}
                  component={SettingsTheme}
                />
                <Route
                  exact
                  path={routes.admin.patientProfile}
                  component={PatientProfile}
                />
                <Route
                  exact
                  path={routes.admin.patientProfileSingle}
                  component={PatientProfile}
                />
                {/*<Route
                  exact
                  path={routes.admin.patientProfileNew}
                  component={PatientProfileCreate}
                />*/}
                <Route
                  exact
                  path={routes.admin.unblindings}
                  component={Unblindings}
                />
                <Route
                  exact
                  path={routes.admin.saeReporting}
                  component={SAEReporting}
                />
                <Route
                  exact
                  path={routes.admin.saeReportingSignle}
                  component={SAEReporting}
                />
                <Route
                  exact
                  path={routes.admin.followUp7Day}
                  component={FollowUp7Day}
                />
                <Route
                  exact
                  path={routes.admin.followUp7DaySingle}
                  component={FollowUp7Day}
                />
                <Route
                  exact
                  path={routes.admin.followUp30Day}
                  component={FollowUp30Day}
                />
                <Route
                  exact
                  path={routes.admin.followUp30DaySingle}
                  component={FollowUp30Day}
                />
                <Route
                  exact
                  path={routes.admin.myProfile}
                  component={MyProfile}
                />
                <Route
                  exact
                  path={routes.admin.enrolments}
                  component={Enrolments}
                />
                <Route
                  exact
                  path={routes.admin.subjectRandomizationList}
                  component={EnrolmentsRandomized}
                />
                <Route
                  exact
                  path={routes.admin.settings}
                  component={AdminSettings}
                />
                <Route
                  exact
                  path={routes.admin.settingsSites}
                  component={SettingsSites}
                />
                <Route
                  exact
                  path={routes.admin.settingsUsers}
                  component={SettingsUsers}
                />
                <Route
                  exact
                  path={routes.admin.settingsUsersPatientPortal}
                  component={SettingsUsersPatientPortal}
                />
                <Route
                  exact
                  path={routes.admin.settingsUsersBulk}
                  component={SettingsUsersBulk}
                />
                <Route
                  exact
                  path={routes.admin.settingsRoles}
                  component={SettingsRoles}
                />
                <Route
                  exact
                  path={routes.admin.settingsRolesSuperAdmin}
                  component={SettingsRolesSuperAdmin}
                />
                <Route
                  exact
                  path={routes.admin.documentsEditor}
                  component={DocumentsEditor}
                />
                <Route
                  exact
                  path={routes.admin.documentsDashboard}
                  component={DocumentManagementDashboard}
                />
                <Route
                  exact
                  path={routes.admin.consentEditorSingle}
                  component={SettingsConsentSingle}
                />
                <Route
                  exact
                  path={routes.admin.consentEditor}
                  component={SettingsConsent}
                />
                <Route
                  exact
                  path={routes.admin.documentsTraining}
                  component={DocumentsTraining}
                />
                <Route
                  exact
                  path={routes.admin.documentsPublic}
                  component={DocumentsPublic}
                />
                <Route
                  exact
                  path={routes.admin.documentsPerSite}
                  component={DocumentsPerSite}
                />
                <Route
                  exact
                  path={routes.admin.documentsPerSitePrivate}
                  component={DocumentsPerSitePrivate}
                />
                <Route
                  exact
                  path={routes.admin.documentsGeneral}
                  component={DocumentsGeneral}
                />
                <Route
                  exact
                  path={routes.admin.documentsGeneralPrivate}
                  component={DocumentsGeneralPrivate}
                />
                <Route
                  exact
                  path={routes.admin.documentsValidation}
                  component={DocumentsValidation}
                />
                <Route
                  exact
                  path={routes.admin.documentsStudyRegulatoryBinder}
                  component={DocumentsStudyRegulatoryBinder}
                />
                <Route
                  exact
                  path={routes.admin.documentsPharmacyBinder}
                  component={DocumentsPharmacyBinder}
                />
                <Route
                  exact
                  path={routes.admin.settingsUsersRoles}
                  component={SettingsUserRoles}
                />
                <Route
                  exact
                  path={routes.admin.settingsGeneral}
                  component={SettingsGeneral}
                />
                <Route
                  exact
                  path={routes.admin.auditLogs}
                  component={AuditLogs}
                />
                <Route
                  exact
                  path={routes.admin.simulation}
                  component={Simulation}
                />
                <Route
                  exact
                  path={routes.admin.drugs}
                  component={DrugsEditor}
                />
                <Route
                  exact
                  path={routes.admin.enrollmentListAdmin}
                  component={EnrolmentsRandomize}
                />
                <Route
                  exact
                  path={routes.admin.validateRandomizationAdmin}
                  component={ValidateRandomization}
                />
                <Route
                  exact
                  path={routes.admin.inventory}
                  component={Inventory}
                />
                <Route
                  exact
                  path={routes.admin.profileList}
                  component={ProfileList}
                />
                <Route
                  exact
                  path={routes.admin.reporting}
                  component={Reporting}
                />
                <Route
                  exact
                  path={routes.admin.randomize}
                  component={RandomizePage}
                />
                <Route
                  exact
                  path={routes.admin.randomizeOld}
                  component={RandomizePageOld}
                />
                <Route
                  exact
                  path={routes.admin.financeCustomers}
                  component={FinanceCustomersEditor}
                />
                <Route
                  exact
                  path={routes.admin.qualityControl}
                  component={QualityControl}
                />
                <Route
                  exact
                  path={routes.admin.financePrices}
                  component={FinancePricesEditor}
                />
                <Route
                  exact
                  path={routes.admin.financeInvoices}
                  component={FinanceInvoicesEditor}
                />
                <Route
                  exact
                  path={routes.admin.financeGeneratedEvents}
                  component={FinanceGeneratedEvents}
                />
                <Route
                  exact
                  path={routes.admin.newsletter}
                  component={Newsletter}
                />
                <Route
                  exact
                  path={routes.admin.consentInvalid}
                  component={ConsentError}
                />
                <Route
                  exact
                  path={routes.admin.documentsEtmfSchema}
                  component={DocumentsEtmfSchema}
                />
                <Route
                  exact
                  path={routes.admin.permutedBlocks}
                  component={PermutedBlocks}
                />
                <Route
                  exact
                  path={routes.admin.languages}
                  component={SettingsLanguages}
                />
                <Route
                  exact
                  path={routes.admin.patientEvents}
                  component={SettingsPatientEvents}
                />
                <Route
                  exact
                  path={routes.admin.translations}
                  component={SettingsTranslations}
                />
                <Route
                  exact
                  path={routes.admin.customFormsList}
                  component={CustomFormList}
                />
                <Route
                  exact
                  path={routes.admin.wizardConfig}
                  component={WizardConfig}
                />
                <Route
                  exact
                  path={routes.admin.customFormsCreate}
                  component={CustomFormCreate}
                />
                <Route
                  exact
                  path={routes.admin.customFormsUpdate}
                  component={CustomFormUpdate}
                />
                <Route
                  exact
                  path={routes.admin.delegationLogs}
                  component={DelegationLogs}
                />
                <Route
                  exact
                  path={routes.admin.delegationLog}
                  component={EditDelegation}
                />
                <Route
                  exact
                  path={routes.admin.delegationLogsSigning}
                  component={DelegationLogsSigning}
                />
                <Route
                  exact
                  path={routes.admin.unassignedConsentRecords}
                  component={ConsentUnassignedRecords}
                />
                <Route
                  exact
                  path={routes.admin.delegationLogsSigningForm}
                  component={EditDelegationLogSigning}
                />
                <Route
                  exact
                  path={routes.admin.specimenSampleEditor}
                  component={SpecimenSampleEditor}
                />
                <Route
                  exact
                  path={routes.admin.specimenSampleSettings}
                  component={SpecimenSamplesSettings}
                />
                <Route
                  exact
                  path={routes.admin.samlConfig}
                  component={SamlConfig}
                />
                <Route
                  exact
                  path={routes.admin.samlLogin}
                  component={SamlLogin}
                />
                <Route
                  exact
                  path={routes.admin.emailTemplates}
                  component={EmailTemplates}
                />
                <Route exact path="*" component={NotFound} />
              </Switch>
            </PageLayout>
          </Router>
        </React.Fragment>
        <PrivacyConsent />
        <WindowDimensions />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  userInfo: getUserInfo(state),
  languages: getLanguages(state),
  theme: getTheme(state),
});

const mapDispatchToProps = {
  setPermissions,
  setAccountInfo,
  getSettingsSites,
  setAppSettings,
  logout,
  updateUser,
  fetchTheme,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(App));



// WEBPACK FOOTER //
// ./src/containers/App/App.js